import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';

const SelectedIcon = ({ disabled = false }) => {
  const classes = classNames('ws-ui-selected-icon', { 'ws-ui-selected-icon--disabled': disabled });

  return (
    <div className={classes}>
      <Icon glyph="check" type="inherit" />
    </div>
  );
};

export default SelectedIcon;
